import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Redux from 'redux'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CloseX} from './CloseX';
import {ScreenDoor} from './ScreenDoor';


class FAQProps extends Tgcc.BaseProps {
    content: string;
    question: string;
}

const boxStyle: React.CSSProperties = {
    height: '290px',
    width: '430px',
    position: 'absolute',
    top: '50%',
    marginTop: '-120px',
    left: '50%',
    marginLeft: '-215px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    fontSize:'17px',
    color:'#404041',
    textAlign:'left',
    '@media (max-width:414px)': {
        width:'325px',
        marginLeft:'-184px',
        height:'400px',
        top:'40%'
    },
    '@media (max-width:320px)': {
        width:'280px',
        marginLeft:'-160px',
        top:'30%'
    }
};
const questionHeader: React.CSSProperties = {
    textAlign:'center',
    fontSize:'25px',
    color:'black',
    fontFamily:"Rosewood"
    
}
const contentBox: React.CSSProperties = {
    border:'1px solid rgba(77, 77, 77, 0.6)',
    padding:'5px',
    overflow:'auto',
    height:'92%',
    marginTop:'20px'
}

export class _FAQContent extends React.Component<FAQProps, any> {

    
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
    render() {
        return (
            <ScreenDoor>
                <div style={boxStyle}>
                        <CloseX closeAction={this.cancel} />
                        <div style={questionHeader}>{this.props.question}</div>
                        <div style={contentBox}>
                            {this.props.content}
                        </div>
                </div>
            </ScreenDoor>
           
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var FAQContent = connect(mapStateToProps)(Radium(_FAQContent));